var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mic-com notice"},[_c('van-notice-bar',{attrs:{"text":_vm.config.content,"left-icon":"volume-o","color":_vm.config.color,"background":_vm.config.bg_color},on:{"click":_vm.onclick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }